import { takeLatest, put, call } from 'redux-saga/effects';
import { updateNotificationsAction } from './actions';
import * as API from '../../utils/API';
import { NOTIFICATIONS } from '../../constants/endpointConstants';

function* updateNotificationsSaga({ payload, serverCookies }) {
  try {
    const response = yield call(API.updateOne, NOTIFICATIONS, payload.id, { status: 'dismissed' }, null, serverCookies);
    yield put(updateNotificationsAction.success(response?.data));
    if (payload.callback) {
      payload.callback();
    }
  } catch (err) {
    yield put(updateNotificationsAction.failure(err));
  } finally {
    yield put(updateNotificationsAction.fulfill());
  }
}

export default function* notificationsSaga() {
  yield takeLatest(updateNotificationsAction.TRIGGER, updateNotificationsSaga);
}
